var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-card', {
    staticClass: "mb-2",
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-title', {
    staticClass: "subtitle-2 font-weight-bold"
  }, [_vm._v(" " + _vm._s(_vm.title) + " ")]), _c('v-card-text', [_c('v-data-table', {
    attrs: {
      "item-key": "tempId",
      "items": _vm.items,
      "headers": _vm.headers,
      "show-select": "",
      "single-select": "",
      "hide-default-footer": "",
      "disable-sort": "",
      "items-per-page": -1
    },
    scopedSlots: _vm._u([{
      key: "item.index",
      fn: function fn(_ref) {
        var item = _ref.item;
        return [_vm._v(_vm._s(_vm.getItemIndex(item)))];
      }
    }, {
      key: "item.term",
      fn: function fn(_ref2) {
        var item = _ref2.item;
        return [_c('v-select', {
          attrs: {
            "value": item.term,
            "items": _vm.terms,
            "hide-details": "",
            "dense": "",
            "outlined": ""
          },
          on: {
            "input": function input(value) {
              return _vm.setItemValue(item, value, true);
            }
          }
        })];
      }
    }, {
      key: "item.description",
      fn: function fn(_ref3) {
        var item = _ref3.item;
        return [_c('v-text-field', {
          attrs: {
            "value": item.description,
            "hide-details": "",
            "dense": "",
            "outlined": ""
          },
          on: {
            "input": function input(value) {
              return _vm.setItemValue(item, value);
            }
          }
        })];
      }
    }, {
      key: "item.actions",
      fn: function fn(_ref4) {
        var item = _ref4.item;
        return [_c('v-icon', {
          on: {
            "click": function click($event) {
              return _vm.removeItem(item);
            }
          }
        }, [_vm._v("mdi-minus-circle-outline")])];
      }
    }], null, true),
    model: {
      value: _vm.selected,
      callback: function callback($$v) {
        _vm.selected = $$v;
      },
      expression: "selected"
    }
  }), _c('v-divider'), _c('table-action-footer', {
    attrs: {
      "selected": _vm.selected,
      "className": "mb-4 no-border-top"
    },
    model: {
      value: _vm.items,
      callback: function callback($$v) {
        _vm.items = $$v;
      },
      expression: "items"
    }
  }, [_c('v-icon', {
    attrs: {
      "slot": "right"
    },
    on: {
      "click": _vm.addItem
    },
    slot: "right"
  }, [_vm._v("mdi-plus-circle-outline")])], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }